import React, { useState, useEffect } from "react";
import axios from "axios";
import { AvailableLaborCard } from "./ExternalJobsSection";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BalcaoPublicoPage() {
  const [offerType, setOfferType] = useState("vaga");
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const src = new URLSearchParams(window.location.search).get("src") === "qr" ? "qr" : "link";
    axios.post(`${API}/balcao/track-visit`, { source: src }).catch(() => {});
    axios.get(`${API}/public/stats`).then((r) => setStats(r.data)).catch(() => {});
  }, []);
  const [rawText, setRawText] = useState("");
  const [organizing, setOrganizing] = useState(false);
  const [fields, setFields] = useState({ title: "", city: "", contact: "", link: "", submitter_name: "", details: "" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const setField = (k, v) => setFields((f) => ({ ...f, [k]: v }));

  const organize = async () => {
    if (rawText.trim().length < 15) {
      setError("Cole o texto completo do anúncio primeiro.");
      return;
    }
    setError("");
    setOrganizing(true);
    try {
      const res = await axios.post(`${API}/balcao/organize`, { raw_text: rawText });
      setFields((f) => ({
        ...f,
        title: res.data.title || f.title,
        city: res.data.city || f.city,
        contact: res.data.contact || f.contact,
        details: res.data.details || f.details,
      }));
    } catch (e) {
      setError(e.response?.data?.detail || "Não consegui organizar — preencha os campos abaixo manualmente.");
    } finally {
      setOrganizing(false);
    }
  };

  const submit = async () => {
    if (fields.title.trim().length < 5) {
      setError("Informe um título para o anúncio (mínimo 5 letras).");
      return;
    }
    setError("");
    setSending(true);
    try {
      await axios.post(`${API}/balcao/submit`, {
        offer_type: offerType,
        raw_text: rawText,
        ...fields,
      });
      setDone(true);
    } catch (e) {
      setError(e.response?.data?.detail || "Erro ao enviar. Tente novamente.");
    } finally {
      setSending(false);
    }
  };

  const reset = () => {
    setDone(false);
    setRawText("");
    setFields({ title: "", city: "", contact: "", link: "", submitter_name: "", details: "" });
    setError("");
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-800 to-green-950 py-8 px-4" data-testid="balcao-publico-page">
      <div className="max-w-lg mx-auto">
        <div className="text-center mb-6">
          <img src="/icon-192x192.png" alt="HeveaTalent" className="w-20 h-20 rounded-2xl mx-auto shadow-lg" />
          <h1 className="text-3xl font-bold text-white mt-4">Balcão de Empregos da Seringueira</h1>
          <p className="text-green-200 mt-2 text-sm">
            Vagas e mão de obra para sangria de seringueira. <strong className="text-white">Grátis.</strong>
            <br />Viu no grupo? Cole aqui que a gente divulga.
          </p>
        </div>

        {stats && (
          <div className="bg-white/10 border border-white/20 rounded-xl px-3 py-2 mb-4 text-center text-green-100 text-xs sm:text-sm" data-testid="balcao-social-proof">
            ✅ {stats.active_jobs} vaga{stats.active_jobs !== 1 ? "s" : ""} ativa{stats.active_jobs !== 1 ? "s" : ""} · 👷 {stats.professionals} profissiona{stats.professionals !== 1 ? "is" : "l"} · 🌳 {stats.employers} produtor{stats.employers !== 1 ? "es" : ""}{stats.matches > 0 ? ` · 🤝 ${stats.matches} ${stats.matches !== 1 ? "contratações feitas" : "contratação feita"}` : ""} · Atualizado hoje
            <a href="/vagas" className="block underline text-white mt-1" data-testid="balcao-cities-link">📍 Ver vagas por cidade →</a>
            <a href="/cursos" className="block underline text-white mt-1" data-testid="balcao-cursos-link">🎓 Cursos gratuitos de sangria →</a>
          </div>
        )}

        <div className="bg-white rounded-2xl shadow-xl p-5">
          {done ? (
            <div className="text-center py-6" data-testid="balcao-success">
              <div className="text-5xl mb-3">✅</div>
              <h2 className="text-xl font-bold text-green-800">Recebido!</h2>
              <p className="text-gray-600 mt-2 text-sm">
                Seu anúncio vai ao ar no Balcão após a aprovação da equipe HeveaTalent.
              </p>
              <button
                onClick={reset}
                data-testid="balcao-send-another"
                className="mt-5 w-full py-3 rounded-xl bg-green-700 text-white font-semibold hover:bg-green-800"
              >
                Enviar outro anúncio
              </button>
            </div>
          ) : (
            <>
              <div className="grid grid-cols-2 gap-2 mb-4">
                <button
                  onClick={() => setOfferType("vaga")}
                  data-testid="balcao-type-vaga"
                  className={`py-3 px-2 rounded-xl text-sm font-semibold border-2 transition-colors ${
                    offerType === "vaga" ? "border-green-700 bg-green-50 text-green-800" : "border-gray-200 text-gray-500 hover:border-green-300"
                  }`}
                >
                  📢 Tenho uma vaga
                </button>
                <button
                  onClick={() => setOfferType("mao_de_obra")}
                  data-testid="balcao-type-mao"
                  className={`py-3 px-2 rounded-xl text-sm font-semibold border-2 transition-colors ${
                    offerType === "mao_de_obra" ? "border-green-700 bg-green-50 text-green-800" : "border-gray-200 text-gray-500 hover:border-green-300"
                  }`}
                >
                  🙋 Procuro trabalho
                </button>
              </div>

              {offerType === "mao_de_obra" && (
                <div className="mb-4 p-3 bg-sky-50 border border-sky-200 rounded-xl text-sm" data-testid="balcao-perfil-cta">
                  <p className="text-sky-900">
                    💡 <strong>O melhor jeito de ser encontrado:</strong> crie seu perfil grátis na HeveaTalent — produtores
                    buscam sangradores lá todos os dias.
                  </p>
                  <a
                    href="/"
                    className="mt-2 inline-block w-full text-center py-2 rounded-lg bg-sky-600 text-white font-semibold hover:bg-sky-700"
                    data-testid="balcao-create-profile-btn"
                  >
                    Criar meu perfil grátis
                  </a>
                  <p className="text-xs text-sky-700 mt-2">Ou, se preferir, deixe seu contato abaixo que divulgamos:</p>
                </div>
              )}

              <label className="block text-sm font-medium text-gray-700 mb-1">
                Cole o texto do jeito que estava no grupo:
              </label>
              <textarea
                value={rawText}
                onChange={(e) => setRawText(e.target.value)}
                data-testid="balcao-raw-text"
                rows={4}
                placeholder={offerType === "vaga"
                  ? "Ex: Preciso de sangrador pra 15 mil árvores em Barretos, casa boa, falar com João (17) 99123-4567"
                  : "Ex: Sou sangrador com 8 anos de experiência, procuro serviço na região de Rio Preto, meu zap (17) 98888-7777"}
                className="w-full p-3 border border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-green-500 focus:outline-none"
              />
              <button
                onClick={organize}
                disabled={organizing}
                data-testid="balcao-organize-btn"
                className="mt-2 w-full py-2.5 rounded-xl bg-amber-500 text-white font-semibold hover:bg-amber-600 disabled:opacity-60"
              >
                {organizing ? "Organizando..." : "✨ Organizar automaticamente"}
              </button>

              <div className="mt-4 space-y-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Título do anúncio *</label>
                  <input
                    value={fields.title}
                    onChange={(e) => setField("title", e.target.value)}
                    data-testid="balcao-title"
                    placeholder={offerType === "vaga" ? "Ex: Sangrador para 15 mil árvores" : "Ex: Sangrador experiente disponível"}
                    className="w-full p-3 border border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-green-500 focus:outline-none"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Detalhes (remuneração, nº de árvores, moradia...)</label>
                  <textarea
                    value={fields.details}
                    onChange={(e) => setField("details", e.target.value)}
                    data-testid="balcao-details"
                    rows={3}
                    placeholder="Ex: Diária R$ 150 ou 50%, 12 mil árvores, casa disponível, início em novembro"
                    className="w-full p-3 border border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-green-500 focus:outline-none"
                  />
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Cidade</label>
                    <input
                      value={fields.city}
                      onChange={(e) => setField("city", e.target.value)}
                      data-testid="balcao-city"
                      placeholder="Ex: Barretos - SP"
                      className="w-full p-3 border border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-green-500 focus:outline-none"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Contato (zap)</label>
                    <input
                      value={fields.contact}
                      onChange={(e) => setField("contact", e.target.value)}
                      data-testid="balcao-contact"
                      placeholder="(17) 99123-4567"
                      className="w-full p-3 border border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-green-500 focus:outline-none"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Seu nome</label>
                    <input
                      value={fields.submitter_name}
                      onChange={(e) => setField("submitter_name", e.target.value)}
                      data-testid="balcao-name"
                      placeholder="Ex: João Silva"
                      className="w-full p-3 border border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-green-500 focus:outline-none"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Link (se tiver)</label>
                    <input
                      value={fields.link}
                      onChange={(e) => setField("link", e.target.value)}
                      data-testid="balcao-link"
                      placeholder="Opcional"
                      className="w-full p-3 border border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-green-500 focus:outline-none"
                    />
                  </div>
                </div>
              </div>

              {error && (
                <p className="mt-3 text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg p-2" data-testid="balcao-error">
                  {error}
                </p>
              )}

              <button
                onClick={submit}
                disabled={sending}
                data-testid="balcao-submit"
                className="mt-4 w-full py-3.5 rounded-xl bg-green-700 text-white font-bold text-base hover:bg-green-800 disabled:opacity-60"
              >
                {sending ? "Enviando..." : "Enviar para o Balcão"}
              </button>
              <p className="text-[11px] text-gray-400 text-center mt-2">
                ✅ Vai ao ar após aprovação da equipe HeveaTalent
              </p>
            </>
          )}
        </div>

        <div className="mt-6 text-left" data-testid="balcao-labor-section">
          <AvailableLaborCard />
        </div>

        <div className="mt-6 bg-green-900/60 border border-green-700 rounded-2xl p-4 text-center">
          <p className="text-green-100 text-sm font-medium">
            💼 Produtores encontram sangradores na <strong className="text-white">heveatalent.com.br</strong>
          </p>
          <p className="text-green-300 text-xs mt-1">
            Tendência do preço da borracha, clima, comunidade e gestão completa da equipe de sangria.
          </p>
          <a
            href="/"
            data-testid="balcao-know-platform-btn"
            className="mt-3 inline-block px-6 py-2.5 rounded-xl bg-white text-green-800 font-bold text-sm hover:bg-green-50"
          >
            Conhecer a plataforma →
          </a>
        </div>
      </div>
    </div>
  );
}
